import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import ImportSector from "./ImportSector";
import List from "components/list/List";
import Pagination from "components/pagination/Pagination";
import sectorsColumn from "./SectorsList.utils";
import ModalSectorUsersManagement from "./ModalSectorUsersManagement";
import ModalSectorPdcsManagement from "./ModalSectorPdcsManagement";

class SectorsList extends PureComponent {
  state = {
    showModalUsersManagement: false,
    showModalPdcsManagement: false,
    modalUsers: [],
    modalPdcs: [],
    targetDataKey: "",
    sectorInfos: {}
  };

  componentDidMount() {
    this.props.init();
    this.props.getPDCS();
  }

  handleDisplayModalUsers = (usersManagerInAllSectorUsersList, sectorInfos) => {
    this.setState({
      modalUsers: usersManagerInAllSectorUsersList,
      showModalUsersManagement: true,
      sectorInfos
    });
  };

  handleDisplayModalPdcs = (pdcsList, sectorInfos) => {
    this.setState({
      modalPdcs: pdcsList,
      showModalPdcsManagement: true,
      sectorInfos
    });
  };

  render() {
    const { showModalUsersManagement, modalUsers, showModalPdcsManagement, modalPdcs, sectorInfos } = this.state;
    const {
      sectorsList,
      page,
      pages,
      pageSize,
      nbItems,
      getNext,
      managerUsersList,
      updateUserSector,
      userInfos,
      currentClientLabel,
      updateLoading
    } = this.props;

    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des secteurs</h2>
          <div class="p-content-page-center-header-buttons">
            <div class="p-content-page-center-header-buttons-item">
              <ImportSector {...this.props} />
            </div>
          </div>
        </div>
        <div class="p-content-page-center-content">
          {!_.isEmpty(sectorsList) && (
            <List
              columns={sectorsColumn(userInfos, this.handleDisplayModalUsers, this.handleDisplayModalPdcs)}
              data={sectorsList}
              page={1}
              pages={1}
              defaultText="Aucun secteur trouvé."
            />
          )}
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>
          <ModalSectorUsersManagement
            sectorInfos={sectorInfos}
            managerUsers={managerUsersList}
            showModal={showModalUsersManagement}
            closeModal={() =>
              this.setState({
                showModalUsersManagement: false,
                modalUsers: [],
                sectorInfos: {}
              })
            }
            usersManagerInAllSectorUsersList={modalUsers}
            updateUserSector={updateUserSector}
            userInfos={userInfos}
            updateLoading={updateLoading}
          />
          <ModalSectorPdcsManagement
            //add function that call action to update store
            // managerUsers={managerUsersList}
            title={sectorInfos.sector_label}
            showModal={showModalPdcsManagement}
            closeModal={() =>
              this.setState({
                showModalPdcsManagement: false,
                modalPdcs: [],
                sectorInfos: {}
              })
            }
            data={modalPdcs}
            sector_id={sectorInfos.sector_id}
          />
        </div>
      </div>
    );
  }
}

SectorsList.propTypes = {
  sectorsList: PropTypes.array,
  page: PropTypes.number,
  pages: PropTypes.number,
  pageSize: PropTypes.number,
  nbItems: PropTypes.number,
  getNext: PropTypes.function
};

export default SectorsList;



// WEBPACK FOOTER //
// src/containers/metier/sectors/SectorsList.js